export class ItemSelector {
    config:any;
    items:any;
    validations:any;

    constructor(config, items, validations){
        this.config = config
        this.items = items;
        this.validations = validations;
    }

    getSelectedItemsOid() {
        var selectedItems = [];
        for (var oid in this.items) {
            if (this.items[oid].checked) {
                selectedItems.push(oid);
            }
        }
        return selectedItems;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/shared/sara-selector/item-selector.ts